// extracted by mini-css-extract-plugin
export var compactFilters = "_cv-4";
export var detailImage = "_cv-1";
export var dropdownContainer = "_cv-2";
export var imageContainer = "_cv-0";
export var selectedCard = "_cv-3";